import { call, put, all, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/webRulesSWGGet";
import { arrayToMap, addObjectIdField } from "@p81-common/shell-core-js";
import { hasAccess, resources } from "@p81-common/shell-core-js";
import { hasFeatureFlag, ffKeys } from "@p81-common/shell-core-js";
import { controlledBy } from "@p81-common/shell-core-js";

function* webRulesSWGGet(action) {
  try {
    //check first if the customer have rules, then show his rules and not the default. this is for case the subscription of SWG end.
    let [{ data }, status] = yield all([
      requestWithSubTenantIfNeeded("get", "swg/rule/web"),
      requestWithSubTenantIfNeeded("get", "swg/rule/status"),
    ]);
    // check if the customer have rules and SWG subscription, if not, get default rules
    const shouldFetchDefaultRules =
      hasFeatureFlag(ffKeys.SWG_DEFAULT_RULES) &&
      !hasAccess(resources.SWG_ADDON) &&
      data.webRules.length === 0;
    if (shouldFetchDefaultRules) {
      // customer dont have rules and not SWG subscription, get default rules
      [{ data }, status] = yield all([
        requestWithSubTenantIfNeeded("get", "swg/rule/web/default"),
      ]);
    }

    data.isDefault = shouldFetchDefaultRules;

    data.webRules.forEach((rule) => {
      rule.status = rule.status === "active";
      rule.sources.forEach((source) => {
        // rename types for compatibility with NTC: users -> user, groups -> group
        if (source.type === "users" || source.type === "groups") {
          source.type = source.type.slice(0, -1);
        }
      });
    });

    data.webRules.sort((a, b) => b.priority - a.priority);

    data.swgStatus = status?.data.swgStatus === "active";
    data.controlledBy = status?.data.controlledBy || controlledBy.HSASE;
    data.webRuleDefaultAction = status?.data.webRuleDefaultAction || "allow";
    data.relationships.groups = arrayToMap(
      "id",
      data.relationships.groups || [],
      addObjectIdField
    );
    data.relationships.users = arrayToMap(
      "id",
      data.relationships.users || [],
      addObjectIdField
    );
    data.relationships.categories = arrayToMap(
      "_id",
      data.relationships.categories || []
    );
    data.relationships.applicationControlApplications = arrayToMap(
      "id",
      data.relationships.applicationControlApplications || []
    );

    yield put(actions.requestSuccess(data));
    if (action.resolve) {
      yield call(action.resolve, data);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));
    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.WEB_RULES_SWG_GET_REQUEST, webRulesSWGGet);
}

export default saga;
